export default {"src":"/_next/static/media/Blocknative.59b56c49.svg","height":115,"width":790,"blurWidth":0,"blurHeight":0};